import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { DropDownRowCSSStyleImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownrowcss';

export class ToneOptionDropDownRowCSSStyleImpl extends DropDownRowCSSStyleImpl
{
    getWrapperCSSStyle():object
    {
        return{
             width:'90%',
             height:'40px',
             flexFlow: "row wrap",
             display:'flex',
             flexDirection:'row',
             paddingLeft:'10px',
            //  borderRadius:'0px 0px 8px 8px',
            //  margin:'1px',
             cursor:'pointer',
            //  borderRadius:'0px 0px 8px 8px',
        };
    }

    getInnerWrapperCSSStyle(isEnabled:boolean, isLastIndex: boolean):object
    {
        return{
            width:'87%',
            display:"flex",
            flexDirection:'row',
            flexFlow:'row wrap',
            borderRadius:"25.5px",
            height:'45px',
            cursor:'pointer',
            marginLeft:'15px',
            backgroundColor:this.getResources().getColor(Colors.color_5),
            // display:'inline-block'
        };
    }

    getIconDivCSSStyle():object
    {
        return{
           padding:'9px 6px 0px 6px',
           width:'10%',
           height:'100%',
           cursor:'pointer',
            
        };
    }

    getIconNameLabelCSSStyle(isEnabled:boolean):object
    {
        return{
            lineHeight:'16px',
            width:'90%',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize:"12px",
            paddingTop: "15px",
            paddingLeft: "27px",
            fontFamily: this.getResources().getFontFamily(),
            color: isEnabled ? this.getResources().getColor(Colors.color_2) : "#898989",
            textAlign:"left",
            cursor:'pointer',
           
         };
    }
    getMobileIconNameLabelCSSStyle(isEnabled:boolean):object
    {
        return{
            lineHeight:'16px',
            width:'90%',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize:"12px",
            paddingTop: "15px",
            paddingLeft: "17px",
            fontFamily: this.getResources().getFontFamily(),
            color: isEnabled ? this.getResources().getColor(Colors.color_2) : "#898989",
            textAlign:"left",
            cursor:'pointer',
           
         };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/toneoptions/toneoptiondropdownrowcss.tsx